import { Icon } from '@chakra-ui/react';

export const EmployeeId = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M16.8 12.6C16.8 12.2686 16.5314 12 16.2 12H14.2C13.8686 12 13.6 12.2686 13.6 12.6C13.6 12.9314 13.8686 13.2 14.2 13.2H16.2C16.5314 13.2 16.8 12.9314 16.8 12.6Z"
      fill="currentColor"
    />
    <path
      d="M16.8 15C16.8 14.6686 16.5314 14.4 16.2 14.4H14.2C13.8686 14.4 13.6 14.6686 13.6 15C13.6 15.3314 13.8686 15.6 14.2 15.6H16.2C16.5314 15.6 16.8 15.3314 16.8 15Z"
      fill="currentColor"
    />
    <path
      d="M18.4 8H14.4V5.6C14.4 4.72 13.68 4 12.8 4H11.2C10.32 4 9.6 4.72 9.6 5.6V8H5.6C4.72 8 4 8.72 4 9.6V18.4C4 19.28 4.72 20 5.6 20H18.4C19.28 20 20 19.28 20 18.4V9.6C20 8.72 19.28 8 18.4 8ZM11.2 5.6H12.8V9.6H11.2V5.6ZM18.4 17.4C18.4 17.9523 17.9523 18.4 17.4 18.4H6.6C6.04772 18.4 5.6 17.9523 5.6 17.4V10.6C5.6 10.0477 6.04772 9.6 6.6 9.6H9.6C9.6 10.48 10.32 11.2 11.2 11.2H12.8C13.68 11.2 14.4 10.48 14.4 9.6H17.4C17.9523 9.6 18.4 10.0477 18.4 10.6V17.4Z"
      fill="currentColor"
    />
    <path
      d="M9.6 14.4C10.2627 14.4 10.8 13.8627 10.8 13.2C10.8 12.5373 10.2627 12 9.6 12C8.93726 12 8.4 12.5373 8.4 13.2C8.4 13.8627 8.93726 14.4 9.6 14.4Z"
      fill="currentColor"
    />
    <path
      d="M11.264 15.344C10.752 15.12 10.192 15 9.6 15C9.008 15 8.448 15.12 7.936 15.344C7.488 15.536 7.2 15.968 7.2 16.456V16.8H12V16.456C12 15.968 11.712 15.536 11.264 15.344Z"
      fill="currentColor"
    />
  </Icon>
);
